import Badge, { BadgeTone } from './Badge'

export type Level = 'org' | 'team' | 'profile'

// Ink tonal ramp encodes hierarchy depth: org (top) strongest, profile lightest.
// Kept neutral so Arwen red stays reserved for actions and brand moments.
const TONES: Record<Level, BadgeTone> = {
    org: 'solid',
    team: 'muted',
    profile: 'faint'
}

const LABELS: Record<Level, string> = { org: 'Org', team: 'Team', profile: 'Profile' }

type Props = {
    level: Level
    /** Appended as `×n` — used where one pill stands for several nodes. */
    count?: number
    /** Overrides the default label; rendered uppercase either way. */
    label?: string
}

export default function LevelPill({ level, count, label }: Props) {
    return (
        <Badge tone={TONES[level]} size="tiny" weight="bold" caps>
            {label ?? LABELS[level]}
            {count !== undefined ? ` ×${count}` : ''}
        </Badge>
    )
}
